import { styled, Typography } from "@mui/material";
import LoadingSVG from "@shared/loadingSVG";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const Container = styled("div")`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;

const SubContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0% 14%;
  text-align: center;
`;

function Loader() {
  const { t } = useTranslation();
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMessage(true);
    }, 3000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  return (
    <Container>
      <SubContainer>
        <LoadingSVG />
        {showMessage && (
          <Typography color="#ffffff">
            {t("please_wait", {
              defaultValue: "This may take a moment. Please wait.",
            })}
          </Typography>
        )}
      </SubContainer>
    </Container>
  );
}

export default Loader;
